"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointDeletedEventData = void 0;
class EndpointDeletedEventData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointDeletedEventData.attributeTypeMap;
    }
}
exports.EndpointDeletedEventData = EndpointDeletedEventData;
EndpointDeletedEventData.discriminator = undefined;
EndpointDeletedEventData.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointUid",
        "baseName": "endpointUid",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=EndpointDeletedEventData.js.map